import React from "react";
import { motion } from "framer-motion";
import Marquee from "react-fast-marquee";

const brands = [
  { name: "Nike", logo: "NIKE" },
  { name: "Adidas", logo: "ADIDAS" },
  { name: "Lululemon", logo: "LULULEMON" },
  { name: "MyProtein", logo: "MYPROTEIN" },
  { name: "Gymshark", logo: "GYMSHARK" },
  { name: "Reebok", logo: "REEBOK" },
  { name: "Under Armour", logo: "UNDER ARMOUR" },
  { name: "Peloton", logo: "PELOTON" },
  { name: "Fitbit", logo: "FITBIT" },
  { name: "Herbalife", logo: "HERBALIFE" },
];

const collaborations = [
  {
    brand: "Nike",
    campaign: "Move With Purpose",
    type: "IG Reels + Stories",
    reach: "2.4M Impressions",
    result: "180% above benchmark",
  },
  {
    brand: "Gymshark",
    campaign: "Summer Shred Series",
    type: "YouTube + IG Feed",
    reach: "1.8M Impressions",
    result: "3.2x ROAS",
  },
  {
    brand: "Lululemon",
    campaign: "Mindful Movement",
    type: "Full Campaign",
    reach: "3.1M Impressions",
    result: "12K link clicks",
  },
  {
    brand: "MyProtein",
    campaign: "Fuel Your Goals",
    type: "IG Reels + Affiliate",
    reach: "1.5M Impressions",
    result: "4.7% conversion rate",
  },
];

export default function PastCollaborations() {
  return (
    <section
      id="past-collaborations"
      data-testid="past-collaborations-section"
      className="py-24 md:py-32 bg-[#0A0A0A] relative overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
          className="mb-16"
        >
          <p className="text-xs sm:text-sm uppercase tracking-[0.2em] font-bold text-[#FF3B30] mb-4">
            Trusted By
          </p>
          <h2
            data-testid="collaborations-heading"
            className="font-['Barlow_Condensed'] text-4xl sm:text-5xl font-bold uppercase tracking-tight text-white"
          >
            Past Collaborations
          </h2>
        </motion.div>
      </div>

      {/* Brand Logo Marquee */}
      <motion.div
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 0.8 }}
        className="mb-20"
        data-testid="brand-marquee"
      >
        <Marquee
          speed={40}
          gradient={true}
          gradientColor="#0A0A0A"
          gradientWidth={100}
          className="py-8"
        >
          {brands.map((brand, i) => (
            <div
              key={i}
              className="mx-10 md:mx-16 flex items-center justify-center"
            >
              <span className="font-['Barlow_Condensed'] text-2xl md:text-3xl font-black uppercase tracking-wider text-white/20 hover:text-white/60 transition-colors duration-400 cursor-default select-none">
                {brand.logo}
              </span>
            </div>
          ))}
        </Marquee>
      </motion.div>

      {/* Collaboration Cards */}
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24">
        <motion.div
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, margin: "-100px" }}
          variants={{
            hidden: { opacity: 0 },
            show: { opacity: 1, transition: { staggerChildren: 0.12 } },
          }}
          className="grid grid-cols-1 md:grid-cols-2 gap-6"
        >
          {collaborations.map((collab, i) => (
            <motion.div
              key={collab.brand}
              variants={{
                hidden: { opacity: 0, y: 30 },
                show: { opacity: 1, y: 0, transition: { duration: 0.5 } },
              }}
              data-testid={`collab-card-${collab.brand.toLowerCase()}`}
              className="bg-[#121212] border border-white/10 rounded-xl p-8 hover:-translate-y-1 hover:border-white/30 transition-all duration-300 group"
            >
              <div className="flex items-start justify-between mb-6">
                <div>
                  <h3 className="font-['Barlow_Condensed'] text-2xl font-bold uppercase text-white group-hover:text-[#FF3B30] transition-colors">
                    {collab.brand}
                  </h3>
                  <p className="text-sm text-white/40 mt-1">{collab.campaign}</p>
                </div>
                <span className="text-xs uppercase tracking-wider font-bold text-[#007AFF] bg-[#007AFF]/10 px-3 py-1.5">
                  {collab.type}
                </span>
              </div>
              <div className="flex items-center gap-8">
                <div>
                  <p className="text-xs uppercase tracking-wider text-white/30 mb-1">Reach</p>
                  <p className="text-sm font-bold text-white font-['JetBrains_Mono']">
                    {collab.reach}
                  </p>
                </div>
                <div className="w-px h-8 bg-white/10" />
                <div>
                  <p className="text-xs uppercase tracking-wider text-white/30 mb-1">Result</p>
                  <p className="text-sm font-bold text-[#FF3B30] font-['JetBrains_Mono']">
                    {collab.result}
                  </p>
                </div>
              </div>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
}
